module.exports = __webpack_public_path__ + "static/media/BrightBee_FB-Ad.36bea259.png";